<template>
  <p class="c-label">{{ label }}</p>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.c-label {
  font-size: 17px!important;
  font-weight: bold!important;
  display: block!important;
  padding-bottom: 6px!important;
  position: relative!important;
  margin: 0 0 20px;
  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 3px;
    background: $main_color;
  }
}

</style>
